<template>
  <div class="projects">
    <div class="projects-header">
      <main-title>Проекты</main-title>
      <main-button color="secondary-fill" @click="$emit('createProjectClick')" class="projects-create-button"
        >Создать</main-button
      >
    </div>
    <main-input placeholder="Поиск" v-model="searchQuery" class="projects-search" type="text" />

    <div v-if="!loading" class="projects-list">
      <Project
        @projectsUpdated="$emit('projectsUpdated')"
        :key="project.id"
        :project="project"
        v-for="project in resultQuery"
        :openEditProjectModal="openEditProjectModal"
      />
    </div>
    <loader class="projects-loader" v-if="loading" />
  </div>
</template>

<script>
import MainButton from "./ui/MainButton.vue";
import Input from "./ui/Input.vue";
import MainTitle from "./ui/MainTitle.vue";
import Project from "./Project.vue";
import Loader from "./ui/Loader.vue";

export default {
  data() {
    return {
      searchQuery: "",
      isContextMenuOpen: false,
    };
  },
  props: {
    projects: Array,
    loading: {
      type: Boolean,
      require: false,
    },
    openEditProjectModal: Function,
  },
  computed: {
    resultQuery() {
      if (this.searchQuery) {
        return this.projects.filter((item) => {
          return this.searchQuery
            .toLowerCase()
            .split(" ")
            .every((v) => item.name.toLowerCase().includes(v));
        });
      } else {
        return this.projects;
      }
    },
  },
  components: { MainButton, "main-input": Input, MainTitle, Project, Loader },
};
</script>

<style scoped>
.projects {
  position: relative;
  padding: 16px;
  border: 1px solid #d5d5df;
  border-radius: 4px;
  max-height: 100%;
  overflow: auto;
}

@media screen and (max-width: 900px) {
  .projects {
    max-height: none;
  }
}
.projects-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 19px;
}

.projects-list {
  margin-top: 32px;
}

.projects-loader {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.projects-create-button {
  height: 36px;
}
</style>
